function detectWebpSupport() {
  const canvas = document.createElement('canvas')

  if (!!(canvas.getContext && canvas.getContext('2d'))) {
    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }

  return false
}

export default {
  namespaced: true,

  state: {
    canUseWebp: undefined,
  },

  getters: {
    canUseWebp(state) {
      if (state.canUseWebp === undefined) {
        state.canUseWebp = detectWebpSupport()
      }

      return state.canUseWebp
    },
  },
}
